import { formatDate } from '@ynap/intl-formatters'

const DATE_FORMAT_OPTIONS = { year: 'numeric', month: 'short', day: 'numeric' }
const SHORT_DATE_FORMAT_OPTION = { month: 'short', day: 'numeric' }

export default function getFormattedDate(date: string, localeId: string, format: 'regular' | 'short' = 'regular'): string {
    const formatOptions = format === 'short' ? SHORT_DATE_FORMAT_OPTION : DATE_FORMAT_OPTIONS
    return formatDate(new Date(date), formatOptions, localeId)
}
